import { type MutationOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ReqReloadCaseDataMutation, type ResReloadCaseDataMutation } from './types'

export const reloadCaseDataMutation: MutationOptions<ResReloadCaseDataMutation, unknown, ReqReloadCaseDataMutation> = {
  mutationFn: (payload) =>
    w
      .query({ caseNumber: payload.caseNumber })
      .get(`${API_ENDPOINTS.business.v1.ocr.reload.index}/${payload.taskId}`)
      .json(),
}
